import React from 'react';
const buys = ['la sensación de llegar a casa y respirar tranquilidad.', 'un momento para desconectarse del estrés.', 'un regalo con significado.', 'una experiencia.'];
export function BigIdea() {
  return <section className="w-full bg-[#2a2438] px-5 py-14 text-white" data-id="element-41" data-mp="2uachyznyki63">
      <div className="mx-auto max-w-md text-center" data-id="element-42" data-mp="2z8nrtae96sob">
        <p className="text-sm font-semibold uppercase tracking-widest text-[#c9b8ea]" data-id="element-43" data-mp="2z7cn98czhgw5">
          La mayoría comete el mismo error
        </p>
        <h2 className="mt-3 font-serif-display text-3xl font-bold leading-tight" data-id="element-44" data-mp="26ixc4wwz3iq3">
          Creen que venden velas, jabones o difusores.
        </h2>
        <p className="mt-4 text-base text-white/70" data-id="element-45" data-mp="2bh8ll6jcvr7s">
          Pero las personas no compran un aroma. Compran…
        </p>

        <div className="mt-6 space-y-3" data-id="element-46" data-mp="2gb307vk3tg00">
          {buys.map(b => <div key={b} className="rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white/85" data-id="element-47" data-mp="1itm8n7o8na89">
              {b}
            </div>)}
        </div>

        <div className="mt-8 rounded-2xl border border-[#d8c19a]/40 bg-[#d8c19a]/10 p-5" data-id="element-48" data-mp="2u3lp6ziphdr3">
          <p className="font-serif-display text-2xl font-semibold leading-snug text-[#e6d3ae]" data-id="element-49" data-mp="2p4r7y20dzx93">
            Cuando una marca entiende esto, deja de competir por precio y empieza a vender por valor.
          </p>
        </div>
      </div>
    </section>;
}